<div class="row">
  <div *ngIf="showThumbnails" class="col-3 col-md-3 bfs-list-thumbnail">
    <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
       [routerLink]="[itemPageRoute]" class="dont-break-out" role="link" tabindex="-1">
      <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
      </ds-thumbnail>
    </a>
    <span *ngIf="linkType === linkTypes.None" class="dont-break-out">
    <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
    </ds-thumbnail>
    </span>
  </div>
  <div [ngClass]="showThumbnails ? 'col-9' : 'col-md-12'">
    <div class="d-flex flex-wrap align-items-start bfs-badge-row">
      <ds-badges *ngIf="showLabel" [object]="dso" [context]="context" [showAccessStatus]="true"></ds-badges>
      <!-- BfS: Schlagwörter als Buttons neben dem Entitätstyp -->
      <ds-subject-badges [object]="dso"></ds-subject-badges>
    </div>

    <ds-truncatable [id]="dso.id" *ngIf="object !== undefined && object !== null">
      <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
         [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
         [innerHTML]="dsoTitle" role="link" tabindex="0"></a>
      <span *ngIf="linkType === linkTypes.None" class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle"></span>
      <span class="text-muted">
        <ds-truncatable-part [id]="dso.id" [minLines]="1">
          <ng-container *ngIf="publicationYear">
            (<span *ngIf="publicationYear" class="item-list-publisher" [innerHTML]="publicationYear"></span>)
          </ng-container>
          <span *ngIf="dso.allMetadata(['dc.creator', 'dc.publisher', 'dc.contributor.author', 'dc.contributor']).length > 0" class="item-list-authors">
            <span *ngFor="let author of allMetadataValues(['dc.creator', 'dc.publisher', 'dc.contributor.author', 'dc.contributor']); let last=last;">
                <span [innerHTML]="formatName(author)"></span>
                <span *ngIf="!last">; </span>
            </span>
          </span>
        </ds-truncatable-part>
      </span>
      <div *ngIf="dso.firstMetadataValue('dc.description.abstract')" class="item-list-abstract">
        <ds-truncatable-part [id]="dso.id" [minLines]="3"><span
          [innerHTML]="firstMetadataValue('dc.description.abstract')"></span>
        </ds-truncatable-part>
      </div>
    </ds-truncatable>
  </div>
</div>
